export enum AccountType {
  Person,
  Company,
}

export enum AccountRole {
  User,
  Admin,
}

export default class User {
  id!: string;
  firstName!: string;
  lastName!: string;
  email!: string;
  emailConfirmed!: boolean;
  vismaUsers!: Array<LocalVismaUser>;
  vismaUser!: LocalVismaUser;
}

export class LocalVismaUser {
  id!: number;
  vismaUserId!: number;
  vismaCustomerNumber!: number;
  firstName!: string;
  lastName!: string;
  email!: string;
  address!: string;
  city!: string;
  zipCode!: string;
  country!: string;
  phoneNumber!: string;
  accountType!: AccountType;
  orgName!: string;
  orgNumber!: string;
}
